import { render } from "./Testimonials.vue?vue&type=template&id=046fbd18&ts=true"
import script from "./Testimonials.vue?vue&type=script&lang=ts"
export * from "./Testimonials.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__